import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Sparkling } from "../../assets/Sparkling.svg"
import { Card } from "../../components/Card";
import { Chat } from "../../components/Chat";
import { SimulationSuggestion } from "../../components/SimulationSuggestion";
import { ReactComponent as ChevronDown } from '../../assets/ChevronDown.svg'
import { ReactComponent as Trash } from '../../assets/Trash.svg'
import AnimateHeight from "react-animate-height";
import styles from './dashboard.module.css'
import clsx from 'clsx'
import { Layout } from "../../components/Layout";
import { ReactComponent as PaperClip } from '../../assets/PaperClip.svg'
import { ReactComponent as Database } from '../../assets/Database.svg'
import { ReactComponent as Code } from '../../assets/Code.svg'
import { ReactComponent as DownloadFile } from '../../assets/DownloadFile.svg'
import { ReactComponent as Close } from '../../assets/Close.svg'
import { ReactComponent as SendIcon } from '../../assets/SendIcon.svg'
import { PillButton } from "../../components/PillButton";

const DashboardPage = () => {
    const navigate = useNavigate()
    const [height, setHeight] = useState<'auto' | 0>(0)

    return (
        <Layout>
            <div className={styles.content}>
                <div className={styles.titleContainer}>
                    <Sparkling color="#4692FC" width={34} height={34} />
                    <p className={styles.title}>Run simulations</p>
                </div>
                <div className={styles.chatContainer}>
                    <input style={{ display: 'none' }} type="file"
                        accept=".png"
                        onChange={(e) => console.log('File selected:', e.target.files?.[0])} />
                    <Chat onSubmit={() => {
                        navigate('/chat/1')
                    }} onChange={(e) => {
                        console.log(e)
                    }} >
                        <div className={styles.footer}>
                            <div className={styles.iconContainer}>
                                <PaperClip cursor='pointer' onClick={() => { console.log('Clicked') }} />
                                <Database cursor='pointer' />
                                <Code cursor='pointer' />
                            </div>
                            <div className={styles.divider} />
                            <div className={styles.iconContainer}>
                                <PillButton label="Context: from builder" prefix={<DownloadFile />} variant="primary" />
                                <PillButton label="Context: from builder" suffix={<Close />} variant="secondary" />
                                <div onClick={() => {
                                    navigate('/chat/1')
                                }} style={{ cursor: 'pointer', height: '32px', width: '32px', backgroundColor: '#000000', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px', marginLeft: 'auto' }}>
                                    <SendIcon />
                                </div>
                            </div>
                        </div>
                    </Chat>
                    <Card>
                        <div onClick={() => setHeight(height === 0 ? 'auto' : 0)} className={styles.previousChatsHeader}>
                            <div className={styles.previousChatsTitle}>
                                <Trash />
                                <p className={styles.previousChatsText}>Previous chats</p>
                            </div>
                            <div className={clsx(styles.chevronIcon, !height && styles.chevronIconClosed)}>
                                <ChevronDown />
                            </div>
                        </div>
                        <AnimateHeight
                            id="example-panel"
                            duration={500}
                            height={height}
                        >
                            <div className={styles.chatHistoryContainer}>
                                <p className={styles.chatHistoryItem}>Chat one</p>
                                <p className={styles.chatHistoryItem}>Chat two</p>
                                <p className={styles.chatHistoryItem}>Chat three</p>
                            </div>
                        </AnimateHeight>
                    </Card>
                </div>
                <SimulationSuggestion />
            </div>
        </Layout>
    )
}

export default DashboardPage